// DS: STU3.6.1
import type { FC } from 'react';

import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  type AddNewFolderClickBiEvent,
  BiContextProvidedValue,
  BiData,
} from '@wix/da-bi/pkg/events';
import { GallectionResourceType } from '@wix/da-shared-react/pkg/types/gallection';
import AddItem from '@wix/da-ds/pkg/AddItem';
import { pushModal } from '@wix/da-shared-react/pkg/Modals/redux/basicActions';
import { ModalType } from '@wix/da-shared-react/pkg/Modals/redux/types';
import { FolderType } from '../../../types/folders';
import {
  getSelectedFolder,
  getFeaturedFolderId,
} from '../../../selectors/studio';

interface Props {
  width: number;
  height: number;
  folderType: FolderType;
}

const CreateFolderCard: FC<Props> = ({ width, height, folderType }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedFolder = useSelector(getSelectedFolder);
  const featuredFolderId = useSelector(getFeaturedFolderId);
  const isFeaturedFolder = selectedFolder?.folderId === featuredFolderId;
  const willCreateSubfolder = (selectedFolder?.folderId || 0) > 0;

  const onCreateFolder = useCallback(() => {
    dispatch(pushModal(ModalType.STUDIO_FOLDER, { params: { folderType } }));
  }, [dispatch, folderType]);

  return (
    <>
      <AddItem
        style={{
          width: `${width - 2}px`,
          height: `${height + 54}px`,
        }}
        subtitle={
          folderType === 'stash'
            ? isFeaturedFolder
              ? t('studio.folderList.create')
              : t('studio.folderList.create.subfolders')
            : willCreateSubfolder
              ? t('studio.published.folderList.create.subfolders')
              : t('studio.published.folderList.create')
        }
        onClick={onCreateFolder}
        biData={BiData<AddNewFolderClickBiEvent>({
          evid: 40,
          itemid: willCreateSubfolder ? selectedFolder?.folderId : undefined,
          typeid:
            folderType === 'stash'
              ? GallectionResourceType.STASH
              : GallectionResourceType.GALLERY,
          sectionname: BiContextProvidedValue,
        })}
      />
    </>
  );
};
CreateFolderCard.displayName = 'CreateFolderCard';

export default CreateFolderCard;
